import $ariService from '../../../axios-instance-ari';

/**
 * Cargar las configuraciones del concepto por empresa.
 * 
 * @param Object { commit } 
 * @param Integer companyId 
 */
export async function getConfigConceptByCompanyId({ commit }, companyId) {
    
    commit('dashboard/load', true, {root: true});

    await $ariService.get(`risk-analysis/config-concept/get-by-company/${companyId}`)
        .then(({data: response}) => {
            
            if (!response.data) return    
            commit('setConfigConcept', response.data)

        })
        .catch(error => this.$vue.$alertError(error.message))
        .finally(() => commit('dashboard/load', false, {root: true}));
}

/**
 * Crear/Editar las configuraciones del concepto por empresa.
 * 
 * @param Object { commit, dispatch } 
 * @param Object payload 
 */
export async function storeConfigConcept({ commit, dispatch }, payload) {
    
    commit('dashboard/load', true, {root: true});

    await $ariService.post('risk-analysis/config-concept', payload)
        .then(({data: response}) => {

            this.$vue.$alertSuccess(response.message);
            dispatch('getConfigConceptByCompanyId', payload.company_id)

        })
        .catch(error => {
            
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);

        })
        .finally(() => commit('dashboard/load', false, {root: true}));
}

/**
 * Descargar Concepto Análisis de Riesgos - Word.
 * 
 * @param Object { commit } 
 * @param Object payload 
 */
export async function downloadRiskAnalysisConceptWord({ commit, state }, payload) {
    
    commit('dashboard/load', true, {root: true});
    commit('analysis/setIdsFiltro', state, {root: true});

    await $ariService.get(`risk-analysis/download-concept-word`, { params: payload })
        .then(({data: response}) => {

            if (!('file' in response.data) || !('templateName' in response.data)) {
                this.$vue.$alertError('Ocurrió un error y no fue posible descargar el Concepto Análisis de Riesgos - Word.')
                return
            }
            
            let linkTemporary = document.createElement("a");
            document.body.appendChild(linkTemporary);
          
            linkTemporary.setAttribute("type", "hidden");
            linkTemporary.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + response.data.file;
            linkTemporary.download = response.data.templateName;
            linkTemporary.click();
          
            document.body.removeChild(linkTemporary);

        })
        .catch(error => this.$vue.$alertError(error.message))
        .finally(() => commit('dashboard/load', false, {root: true}));
}